var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconErrorLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.7714 0 0 44.7714 0 100C0 155.229 44.7714 200 100 200C155.229 200 200 155.229 200 100C199.936 44.798 155.202 0.0641129 100 0ZM100 193.548C48.3347 193.548 6.45161 151.665 6.45161 100C6.45161 48.3347 48.3347 6.45161 100 6.45161C151.665 6.45161 193.548 48.3347 193.548 100C193.492 151.642 151.642 193.492 100 193.548Z",
    fill: "#EF382A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.618 54.3808C144.358 53.1215 142.316 53.1215 141.057 54.3808L99.9987 95.4389L58.9406 54.3808C57.7031 53.0994 55.6608 53.0639 54.3793 54.3014C53.0979 55.5389 53.0624 57.5812 54.2999 58.8627C54.3257 58.8897 54.3523 58.9159 54.3793 58.9421L95.4374 100L54.3793 141.058C53.0979 142.296 53.0624 144.338 54.3003 145.62C55.5382 146.901 57.5802 146.936 58.8616 145.699C58.8886 145.673 58.9148 145.646 58.9406 145.62L99.9987 104.561L141.057 145.62C142.338 146.857 144.38 146.822 145.618 145.541C146.826 144.291 146.826 142.308 145.618 141.058L104.56 100L145.618 58.9421C146.877 57.6824 146.877 55.6405 145.618 54.3808Z",
    fill: "#EF382A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorLg);
export default __webpack_public_path__ + "static/media/icon-error-lg.287107f5.svg";
export { ForwardRef as ReactComponent };